import React, { useEffect, useState } from 'react';
import { ChefHat } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

/**
 * Splash screen shown on first app load. Auto-fades after 1.6 seconds.
 * On native Capacitor builds, the native splash (configured in capacitor.config.ts)
 * is shown FIRST and then this React splash takes over for an additional moment.
 */
export default function Splash() {
  const { t } = useLang();
  const [hide, setHide] = useState(false);
  const [unmount, setUnmount] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHide(true), 1400);
    const t2 = setTimeout(() => setUnmount(true), 2000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (unmount) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-gradient-to-br from-[#F9F6F0] via-[#EFEBE1] to-[#E5DECF] dark:from-neutral-900 dark:via-neutral-900 dark:to-neutral-950 transition-opacity duration-500 ${hide ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-[#C05A42]/20 blur-3xl animate-pulse" />
        <div className="relative h-28 w-28 rounded-3xl bg-[#C05A42] text-white shadow-2xl flex items-center justify-center splash-bounce">
          <ChefHat className="h-14 w-14" strokeWidth={2.2} />
        </div>
      </div>
      <h1 className="mt-6 text-4xl sm:text-5xl font-display font-bold tracking-tight text-[#2C2420] dark:text-neutral-100 splash-fade">
        {t('appName')}
      </h1>
      <p className="mt-2 text-sm text-[#5C4D44] dark:text-neutral-400 splash-fade-delay">
        {t('tagline')}
      </p>
      <div className="mt-10 splash-fade-delay">
        <div className="h-1 w-32 rounded-full bg-[#C05A42]/20 overflow-hidden">
          <div className="h-full w-1/2 bg-[#C05A42] splash-loader" />
        </div>
      </div>
    </div>
  );
}
